import { ApiBuilderType } from 'modules/common/types';
import { RetIsLogsEnabledResponse } from 'modules/logRocket/types';

export const getIsLogsEnabled = (builder: ApiBuilderType) => {
	return builder.query<RetIsLogsEnabledResponse, void>({
		query: () => ({ url: '/log-rocket-configuration/logs' }),
	});
};
